import { AuthenticationActions } from 'react-aad-msal';
import * as types from '../types';

export function appSettingsSucess(data) {
    return {
        type: types.ON_APPSETTINGS_SUCCESS,
        payload: {
            TenantName: data.tenantName,
            TenantId: data.tenantId,
            clientid: data.appId,
            domain: data.domain,
            prefix: data.prefix,
            demoUrl: data.demoUrl,
            redirectUris: data.redirectUris
        },
    };
}
export function acquiredIdTokenSuccess(token) {
  return {
    type: AuthenticationActions.AcquiredIdTokenSuccess,
    payload: { idToken: { rawIdToken: token } },
  };
}

export function acquiredAccessTokenSuccess(token) {
  return {
    type: AuthenticationActions.AcquiredAccessTokenSuccess,
    payload: { accessToken: token },
  };
}

export function loginSuccess(data) {
  return {
    type: AuthenticationActions.LoginSuccess,
    payload: { account: data },
  };
}



